export default "__VITE_ASSET__wR84VknB__"